"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpFormTextarea = void 0;
const lodash_1 = require("lodash");
const vue_property_decorator_1 = require("vue-property-decorator");
const form_input_base_1 = require("./form-input-base");
const form_textarea_html_1 = __importDefault(require("./form-textarea.html"));
let ItpFormTextarea = class ItpFormTextarea extends (0, vue_property_decorator_1.Mixins)(form_input_base_1.FormInputBase) {
    autocomplete;
    rows;
    maxRows;
    resize;
    monospace;
    mode;
    get style() {
        if (this.resize === 'vertical') {
            return {
                resize: 'vertical',
                minHeight: '3rem'
            };
        }
        if (this.resize === 'horizontal') {
            return {
                resize: 'vertical',
                minWidth: '3rem'
            };
        }
        return { resize: 'none' };
    }
    parseValue(value) {
        if (this.mode === 'list') {
            if ((0, lodash_1.isArray)(value) && value.length) {
                return value.join('\n');
            }
            return '';
        }
        return value;
    }
    dumpValue(value) {
        if (this.mode === 'list') {
            if ((0, lodash_1.isString)(value)) {
                const trimmed = value.trim();
                if (trimmed) {
                    return trimmed.split('\n');
                }
            }
            return [];
        }
        return value;
    }
};
exports.ItpFormTextarea = ItpFormTextarea;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Boolean)
], ItpFormTextarea.prototype, "autocomplete", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 3 }),
    __metadata("design:type", Number)
], ItpFormTextarea.prototype, "rows", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 6 }),
    __metadata("design:type", Number)
], ItpFormTextarea.prototype, "maxRows", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'vertical' }),
    __metadata("design:type", String)
], ItpFormTextarea.prototype, "resize", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false }),
    __metadata("design:type", Boolean)
], ItpFormTextarea.prototype, "monospace", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], ItpFormTextarea.prototype, "mode", void 0);
exports.ItpFormTextarea = ItpFormTextarea = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: form_textarea_html_1.default,
        inject: {
            componentContext: 'componentContext',
            formContext: { default: null }
        }
    })
], ItpFormTextarea);
//# sourceMappingURL=form-textarea.js.map